export const ReleaseTag = "v0.92"
export const PatchLevel = 0